import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import MealService from "services/meal.service";

import SortIcon from "assets/icons/Sort.svg";

import MealList from "./MealList";
import MealFilter from "./MealFilter";

import Spinner from "react-bootstrap/Spinner";
import "pages/Meal/Meal.scss";

export function Meal() {
  const [loading, setLoading] = useState(false);
  const [meals, setMeals] = useState([]);

  const defaultMeta = { total_meals: 0, total_pages: 0, current_page: 1 };
  const [meta, setMeta] = useState(defaultMeta);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [page, setPage] = useState(1);

  const [Username, setUsername] = useState(null);
  const [Corporate, setCorporate] = useState(null);
  const [Email, setEmail] = useState(null);
  const [Phone, setPhone] = useState(null);
  const [Plan, setPlan] = useState(null);
  const [Unrated, setUnrated] = useState(null);
  const [Unread, setUnread] = useState(null);
  const [UpdatedBy, setUpdatedBy] = useState(null);
  const [withSkipped, setWithSkipped] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [sortBy, setSortBy] = useState(null);
  const [mealId, setMealId] = useState(null);

  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    authUser();

    const urlParams = new URLSearchParams(window.location.search);

    const meal_id = urlParams.get("meal_id");
    if (meal_id) {
      setMealId(meal_id);
    } else {
      getMeals(1, null);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (mealId) {
      getMeals(1, mealId);
    }
  }, [mealId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstRender) {
      setMealId(null);

      const url = new URL(window.location.href);
      url.searchParams.delete("meal_id");
      window.history.replaceState({}, "", url);

      getMeals(1, null);
    } else {
      setFirstRender(false);
    }
  }, [sortBy]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = () => {
    setShowSort(!showSort);
  };

  const handleSort = (e) => {
    setSortBy(e);
    setShowSort(!showSort);
  };

  const handleSkip = (e) => {
    setWithSkipped(e);
  };

  const authUser = () => {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser?.is_bookdoc_nutritionist) {
      window.location.replace("/eb/");
    }
  };

  const refreshPage = () => {
    getMeals(page);
  };

  const getMeals = (page, meal_id = null) => {
    setPage(page);
    setLoading(true);

    const params = {
      page: page,
      from: startDate,
      to: endDate,
      name: Username,
      email: Email,
      phone: Phone,
      corporate: Corporate,
      plan: Plan,
      unrated: Unrated,
      unread: Unread,
      updatable_type: UpdatedBy,
      with_skipped: withSkipped,
      order: sortBy,
      meal_id: meal_id,
    };

    MealService.listMeals(params)
      .then(
        (data) => {
          setMeals(data.meals);
          setMeta(data.meta);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        setLoading(false);
      });
  };

  const Records = () => {
    if (loading)
      return (
        <tr className="loader">
          <td className="border-bottom-0">
            <Spinner animation="border" className="spinner" />
          </td>
        </tr>
      );
    if (meals.length === 0)
      return (
        <tr className="loader">
          <td className="border-bottom-0">No Meals Available</td>
        </tr>
      );

    return <>{<MealList meals={meals} getMeals={refreshPage} />}</>;
  };

  return (
    <div id="main-content-target" className="meal-page">
      <h1 className="text-danger">Meals</h1>
      <MealFilter
        getMeals={getMeals}
        meta={meta}
        page={page}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <div id="meal-filter-bar" className="">
        <div className="row">
          <div className="input-holder">
            <input
              id="username"
              type="text"
              placeholder="Username"
              className="form-control"
              value={Username || ""}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="input-holder">
            <input
              id="corporate"
              type="text"
              placeholder="Corporate"
              className="form-control"
              value={Corporate || ""}
              onChange={(e) => setCorporate(e.target.value)}
            />
          </div>

          <div className="input-holder">
            <input
              id="email"
              type="text"
              placeholder="Email"
              className="form-control"
              value={Email || ""}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-holder">
            <input
              id="phone"
              type="text"
              placeholder="Phone No."
              className="form-control"
              value={Phone || ""}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>

        <div className="row" style={{ position: "relative" }}>
          <div className="input-holder">
            <select
              id="plan"
              className="form-control px-4"
              value={Plan || ""}
              onChange={(e) => setPlan(e.target.value)}
            >
              <option value="" disabled hidden>
                Plan
              </option>
              <option value="">All</option>
              <option value="premium">Premium</option>
              <option value="premium_plus">Premium+</option>
            </select>
          </div>
          <div className="input-holder">
            <select
              id="rate"
              className="form-control px-4"
              value={Unrated || "false"}
              onChange={(e) => setUnrated(e.target.value)}
            >
              <option value="false" disabled hidden>
                Rate
              </option>
              <option value="false">All</option>
              <option value="true">Unrated</option>
            </select>
          </div>
          <div className="input-holder">
            <select
              id="comment"
              className="form-control px-4"
              value={Unread || "false"}
              onChange={(e) => setUnread(e.target.value)}
            >
              <option value="false" disabled hidden>
                Comment
              </option>
              <option value="false">All</option>
              <option value="true">Unread</option>
            </select>
          </div>
          <div className="input-holder">
            <select
              id="update-by"
              className="form-control px-4"
              value={UpdatedBy || ""}
              onChange={(e) => setUpdatedBy(e.target.value)}
            >
              <option value="" disabled hidden>
                Updated By
              </option>
              <option value="">All</option>
              <option value="AskAbe">AskAbe</option>
              <option value="Doctor">Doctor</option>
              <option value="User">User</option>
            </select>
          </div>
          <button
            className="btn btn-danger py-3 px-10 apply-button"
            onClick={() => {
              setMealId(null);

              const url = new URL(window.location.href);
              url.searchParams.delete("meal_id");
              window.history.replaceState({}, "", url);

              getMeals(1, null);
            }}
          >
            Apply
          </button>

          <button
            className="btn btn-danger py-3 px-10 reset-button"
            onClick={() => {
              const url = new URL(window.location.href);
              url.searchParams.delete("meal_id");
              window.history.replaceState({}, "", url);

              setUsername(null);
              setCorporate(null);
              setEmail(null);
              setPhone(null);
              setPlan(null);
              setUnrated(null);
              setUnread(null);
              setUpdatedBy(null);
              setWithSkipped(false);
              setSortBy(null);

              getMeals(1, null);
            }}
          >
            Reset
          </button>

          <span className="d-flex justify-content-end">
            <div className="filter-checkbox d-none d-xl-block d-lg-block d-md-block d-sm-none">
              <input
                type="checkbox"
                name="IsSkipped"
                className="form-check-input"
                value={withSkipped}
                onChange={(e) => handleSkip(e.target.checked)}
              />
              <span>Skipped</span>

              <button
                id="sort"
                className="border-0 filter-icon pl-4"
                onClick={() => handleChange()}
              >
                <img src={SortIcon} alt="sort" className="px-2" />
                <span>Sort</span>
              </button>

              <div
                id="filter-actions"
                className="conditional-display"
                displayed={showSort.toString()}
              >
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "username_asc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("username_asc")}
                >
                  Username (A - Z)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "username_desc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("username_desc")}
                >
                  Username (Z - A)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "foodname_asc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("foodname_asc")}
                >
                  Foodname (A - Z)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "foodname_desc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("foodname_desc")}
                >
                  Foodname (Z - A)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "submitted_at_desc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("submitted_at_desc")}
                >
                  Submited At (New - Old)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "submitted_at_asc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("submitted_at_asc")}
                >
                  Submited At (Old - New)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "updated_at_desc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("updated_at_desc")}
                >
                  Updated by (New - Old)
                </div>
                <div
                  className={`action-child px-4 py-4 ${
                    sortBy === "updated_at_asc" ? "active" : ""
                  }`}
                  onClick={() => handleSort("updated_at_asc")}
                >
                  Updated by (Old - New)
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
      {loading ? (
        <div className="d-flex justify-content-center my-12">
          <Spinner animation="border" className="spinner" />
        </div>
      ) : (
        <table id="meal-table" className="w-100">
          <tbody>{Records()}</tbody>
        </table>
      )}
    </div>
  );
}

export default Meal;
